import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fadeVariants,
  slideVariants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import arrowDown from "assets/images/ttl/arrow-down.png";

const AllStart = ({ mobile_app, toggleModal, chooseasker_params }) => {
  const title = _.get(
    chooseasker_params,
    "title",
    "The Host will choose The Player"
  );
  const points_text = _.get(chooseasker_params, "points_text", "POINTS");
  const guessers_text = _.get(chooseasker_params, "guessers_text", "Guessers");
  const player_text = _.get(chooseasker_params, "player_text", "The Player");
  const point_100 = _.get(chooseasker_params, "100_point", "+100");
  const point_200 = _.get(chooseasker_params, "200_point", "+200");
  const point_300 = _.get(chooseasker_params, "300_point", "+300");
  const point_100_text = _.get(
    chooseasker_params,
    "100_point_text",
    "Finding the Lie"
  );
  const point_200_text = _.get(
    chooseasker_params,
    "200_point_text",
    "Fooling half"
  );
  const point_300_text = _.get(
    chooseasker_params,
    "300_point_text",
    "Fooling everyone"
  );
  const bottom_text = _.get(
    chooseasker_params,
    "bottom_text",
    "Add your Two Truths and a Lie"
  );
  const modal_button_text = _.get(
    chooseasker_params,
    "modal_button_text",
    "My Two Truths and a Lie"
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`ttl-host-wrapper ${mobile_app ? "mobile-cnt" : "web-cnt"}`}
    >
      <div className="ttl-host">
        <motion.h2
          variants={fadeVariants}
          className={`host-title ${!mobile_app && "web-cnt"}`}
        >
          {title}
        </motion.h2>
        <motion.div
          variants={bounce_right_to_left_variants}
          className="host-points"
        >
          <h4 className="title">{points_text}</h4>
          <p className="roleText">{guessers_text}</p>
          <ul className="ul-div">
            <li>
              <span className="num">{point_100}</span> {point_100_text}
            </li>
          </ul>
          <p className="roleText">{player_text}</p>
          <ul>
            <li>
              <span className="num">{point_200}</span> {point_200_text}
            </li>
            <li>
              <span className="num">{point_300}</span> {point_300_text}
            </li>
          </ul>
        </motion.div>
      </div>
      <div className={`bottom-div ${mobile_app && "mobile-cnt"}`}>
        <motion.div variants={fadeVariants} className="ttl-truth-lie">
          <p className="text">{bottom_text}</p>
          <div className="text-center">
            <button className="down-arrow-icon">
              <img src={arrowDown} alt="" />
            </button>
          </div>
        </motion.div>
        <motion.div
          variants={slideVariants}
          className={`truth-lie-card ${!mobile_app && "web-cnt"}`}
        >
          <button onClick={toggleModal} className="truth-lie-btn">
            {modal_button_text}
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AllStart;
